import * as Yup from 'yup';

export const validationSchema = () =>
  Yup.object({
    purchaseOrderItemTypeId: Yup.string().required('Required').nullable(),
  });
